import { c as _c } from "react/compiler-runtime";
import { diToFormData } from '@onefootprint/core';
import type { VaultData } from '@onefootprint/request-types';
import { Form } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { InvestorProfileFormData } from '../types';
export const RiskToleranceSection = () => {
  const $ = _c(36);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "collectInvestorProfile.riskTolerance"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = {
      label: t1,
      hint: t2,
      value: "conservative"
    };
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t) {
    t4 = t(_temp3);
    $[8] = t;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t(_temp4);
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = {
      label: t4,
      hint: t5,
      value: "moderate"
    };
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t) {
    t7 = t(_temp5);
    $[15] = t;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp6);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t7 || $[20] !== t8) {
    t9 = {
      label: t7,
      hint: t8,
      value: "aggressive"
    };
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== t3 || $[23] !== t6 || $[24] !== t9) {
    t10 = [t3, t6, t9];
    $[22] = t3;
    $[23] = t6;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const options = t10;
  let t11;
  if ($[26] !== t) {
    t11 = t(_temp7);
    $[26] = t;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <h2 className="text-label-2 text-primary">{t11}</h2>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = diToFormData("investor_profile.risk_tolerance");
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== options) {
    t14 = <Form.RadioGroup name={t13} options={options} className="flex flex-col gap-4" />;
    $[31] = options;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t14) {
    t15 = <section className="flex flex-col gap-6">{t12}{t14}</section>;
    $[33] = t12;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  return t15;
};
export default RiskToleranceSection;
function _temp($) {
  return $.conservative.label;
}
function _temp2($_0) {
  return $_0.conservative.description;
}
function _temp3($_1) {
  return $_1.moderate.label;
}
function _temp4($_2) {
  return $_2.moderate.description;
}
function _temp5($_3) {
  return $_3.aggressive.label;
}
function _temp6($_4) {
  return $_4.aggressive.description;
}
function _temp7($_5) {
  return $_5.title;
}